// LazyComponents.tsx - Code-split components for better performance
import { lazy, Suspense } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

// Loading component for lazy-loaded components
const LoadingFallback = ({ message = "Loading..." }: { message?: string }) => (
  <Box sx={{ 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center', 
    minHeight: '50vh', 
    gap: 2 
  }}>
    <CircularProgress size={40} />
    <Typography sx={{ color: '#eceef1' }}>{message}</Typography>
  </Box>
);

// Lazy load main interface components
export const LazyAdminInterface = lazy(() => import('./AdminInterface'));
export const LazyDispatcherInterface = lazy(() => import('./DispatcherInterface'));
export const LazyUnitInterface = lazy(() => import('./UnitInterface'));

// Lazy load radio components (these are the largest)
export const LazyRadioPage = lazy(() => import('./radio/RadioPage'));
export const LazyRadioInterface = lazy(() => import('./radio/RadioInterface'));

// Lazy load unit assignment components
export const LazyShiftCommanderInterface = lazy(() => import('./ShiftCommanderInterface'));
export const LazyBigBoard = lazy(() => import('./BigBoard'));

// Wrapped components with Suspense
export const AdminInterface = (props: any) => (
  <Suspense fallback={<LoadingFallback message="Loading Admin Interface..." />}>
    <LazyAdminInterface {...props} />
  </Suspense>
);

export const DispatcherInterface = (props: any) => (
  <Suspense fallback={<LoadingFallback message="Loading Dispatcher Interface..." />}>
    <LazyDispatcherInterface {...props} />
  </Suspense>
);

export const UnitInterface = (props: any) => (
  <Suspense fallback={<LoadingFallback message="Loading Unit Interface..." />}>
    <LazyUnitInterface {...props} />
  </Suspense>
);

export const RadioPage = (props: any) => (
  <Suspense fallback={<LoadingFallback message="Loading Radio System..." />}>
    <LazyRadioPage {...props} />
  </Suspense>
);

export const RadioInterface = (props: any) => (
  <Suspense fallback={<LoadingFallback message="Initializing Radio Interface..." />}>
    <LazyRadioInterface {...props} />
  </Suspense>
);

export const ShiftCommanderInterface = (props: any) => (
  <Suspense fallback={<LoadingFallback message="Loading Shift Commander Interface..." />}>
    <LazyShiftCommanderInterface {...props} />
  </Suspense>
);

export const BigBoard = (props: any) => (
  <Suspense fallback={<LoadingFallback message="Loading Big Board..." />}>
    <LazyBigBoard {...props} />
  </Suspense>
);
